import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  "data-index": 0
}
const _hoisted_2 = {
  key: 1,
  class: "container flex-container",
  "data-index": 1
}
const _hoisted_3 = { class: "states" }
const _hoisted_4 = { class: "state" }
const _hoisted_5 = { class: "state" }
const _hoisted_6 = { class: "state" }
const _hoisted_7 = { class: "state" }
const _hoisted_8 = { class: "state" }
const _hoisted_9 = { class: "stateContainer" }
const _hoisted_10 = { class: "progress" }
const _hoisted_11 = { class: "stateContainer" }
const _hoisted_12 = { class: "stateContainer" }
const _hoisted_13 = { class: "stateContainer" }
const _hoisted_14 = { class: "stateContainer" }
const _hoisted_15 = {
  key: 2,
  class: "container",
  "data-index": 2
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { style: {"padding-top":"10px"} }
const _hoisted_18 = {
  key: 3,
  class: "container",
  "data-index": 2
}
const _hoisted_19 = {
  key: 4,
  class: "container",
  "data-index": 3
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    name: "game",
    appear: "",
    onBeforeEnter: _cache[38] || (_cache[38] = (e) => _ctx.beforeEnter(<HTMLElement>e)),
    onEnter: _cache[39] || (_cache[39] = (e, done) => _ctx.enter(<HTMLElement>e, done))
  }, [
    (_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToGame && _ctx.backToGame(...args)))
      }, " Back To Options ")
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_2, [
      _cache[50] || (_cache[50] = _createElementVNode("div", { class: "title" }, " State ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[40] || (_cache[40] = _createTextVNode(" Preload Complete ")),
          _createElementVNode("span", {
            class: _normalizeClass(["dot", { active: _ctx.isPreloadComplete }])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[41] || (_cache[41] = _createTextVNode(" Load Complete ")),
          _createElementVNode("span", {
            class: _normalizeClass(["dot", { active: _ctx.isLoadComplete }])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[42] || (_cache[42] = _createTextVNode(" Game Ready ")),
          _createElementVNode("span", {
            class: _normalizeClass(["dot", { active: _ctx.isGameReady }])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[43] || (_cache[43] = _createTextVNode(" Game Busy ")),
          _createElementVNode("span", {
            class: _normalizeClass(["dot", { active: _ctx.isGameBusy }])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[44] || (_cache[44] = _createTextVNode(" Bonus Active ")),
          _createElementVNode("span", {
            class: _normalizeClass(["dot", { active: _ctx.isBonusActive }])
          }, null, 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[45] || (_cache[45] = _createTextVNode(" Load Progress ")),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "progress-bar",
            style: _normalizeStyle({ width: _ctx.getLoadingWidth() })
          }, null, 4)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[46] || (_cache[46] = _createTextVNode(" Game State ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gameState) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "NONE",
          readonly: ""
        }, null, 512), [
          [_vModelText, _ctx.gameState]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[47] || (_cache[47] = _createTextVNode(" Stake ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stake) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "0",
          readonly: ""
        }, null, 512), [
          [_vModelText, _ctx.stake]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[48] || (_cache[48] = _createTextVNode(" Balance ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.balance) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "0",
          readonly: ""
        }, null, 512), [
          [_vModelText, _ctx.balance]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[49] || (_cache[49] = _createTextVNode(" Win ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.win) = $event)),
          type: "text",
          class: "textInput",
          placeholder: "0",
          readonly: ""
        }, null, 512), [
          [_vModelText, _ctx.win]
        ])
      ])
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_15, [
      _cache[52] || (_cache[52] = _createElementVNode("div", { class: "title" }, " Actions ", -1)),
      _createElementVNode("div", null, [
        (!_ctx.soundEnabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button test",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.soundOn && _ctx.soundOn(...args)))
            }, " Sound On "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "button",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.soundOff && _ctx.soundOff(...args)))
            }, " Sound Off "))
      ]),
      _createElementVNode("div", null, [
        (!_ctx.turboEnabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.turboOn && _ctx.turboOn(...args)))
            }, " Turbo On "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "button",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.turboOff && _ctx.turboOff(...args)))
            }, " Turbo Off "))
      ]),
      _createElementVNode("div", null, [
        (!_ctx.helpOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openHelp && _ctx.openHelp(...args)))
            }, " Open Help "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "button",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeHelp && _ctx.closeHelp(...args)))
            }, " Close Help "))
      ]),
      _createElementVNode("div", null, [
        (!_ctx.historyOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openHistory && _ctx.openHistory(...args)))
            }, " Open History "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "button",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeHistory && _ctx.closeHistory(...args)))
            }, " Close History "))
      ]),
      _createElementVNode("div", null, [
        (!_ctx.paytableOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openPaytable && _ctx.openPaytable(...args)))
            }, " Open Paytable "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "button",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closePaytable && _ctx.closePaytable(...args)))
            }, " Close Paytable "))
      ]),
      _createElementVNode("div", null, [
        (!_ctx.paused)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button",
              onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.pause && _ctx.pause(...args)))
            }, " Pause Game "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "button",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.resume && _ctx.resume(...args)))
            }, " Resume Game "))
      ]),
      (_ctx.autoPlayActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "button",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.autoPlayStop && _ctx.autoPlayStop(...args)))
            }, " Stop AutoPlay ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _cache[51] || (_cache[51] = _createTextVNode(" Balance ")),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.forceBalance) = $event)),
          type: "text",
          class: "textInput"
        }, null, 512), [
          [_vModelText, _ctx.forceBalance]
        ]),
        _createElementVNode("div", {
          class: "button",
          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.updateBalance && _ctx.updateBalance(...args)))
        }, " Update Balance ")
      ])
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_18, [
      _cache[53] || (_cache[53] = _createElementVNode("div", { class: "title" }, " Force Custom Error ", -1)),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sendError('INVALID_SESSION')))
      }, " Invalid Session "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sendError('GAME_DISABLED')))
      }, " Game Disabled "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.sendError('GAME_NOT_FOUND')))
      }, " Game Not Found "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.sendError('GAME_ROUND_NOT_FOUND')))
      }, " Game Round Not Found "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.sendError('INVALID_API_KEY')))
      }, " Invalid API Key "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.sendError('EXISTING_IN_PLAY_GAME_ROUND')))
      }, " Existing In-Play Game Round "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.sendError('NO_IN_PLAY_GAME_ROUND')))
      }, " No In-Play Game Round "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.sendError('INVALID_CURRENCY')))
      }, " Invalid Currency "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sendError('INVALID_GAME')))
      }, " Invalid Game "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.sendError('INVALID_WAGER_AMOUNT')))
      }, " Invalid Wager Amount "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.sendError('INVALID_STAKE_AMOUNT')))
      }, " Invalid Stake Amount "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.sendError('INVALID_WIN_AMOUNT')))
      }, " Invalid Win Amount "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.sendError('INSUFFICIENT_FUNDS')))
      }, " Insufficient Funds "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.sendError('NETWORK_ERROR')))
      }, " Network Error "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.sendError('SPENDING_LIMIT_EXCEEDED')))
      }, " Spending Limit Exceeded "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.sendError('PLAYER_IP_BLOCKED')))
      }, " Player IP Blocked "),
      _createElementVNode("div", {
        class: "button",
        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.sendError('FREE_ROUND_NOT_FOUND')))
      }, " Free Round Not Found ")
    ])),
    (_openBlock(), _createElementBlock("div", _hoisted_19, [
      _cache[54] || (_cache[54] = _createElementVNode("div", { class: "title" }, " Events ", -1)),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.output) = $event)),
          class: "textInput",
          style: {"height":"500px","font-size":"12px","text-align":"left"},
          readonly: ""
        }, null, 512), [
          [_vModelText, _ctx.output]
        ])
      ])
    ]))
  ], 32))
}